export { useUpdateApplicationDoc } from './useUpdateApplicationDoc';
